<template>
    <table class="c-table resource-table">
        <thead v-if="!isCollectionLoading && hasData" class="resource-table__header">
            <tr>
                <th v-if="selectAllRowsFeature" class="c-table__cell c-table__cell--head center hidden-xs hidden-sm">
                    <input type="checkbox" @change="emit('change:select-all', $event)" />
                </th>

                <template v-for="tableColumn in tableColumns" :key="tableColumn.id">
                    <sort-th
                        v-if="isSortEnable && tableColumn.sort"
                        class="c-table__cell c-table__cell--head center hidden-xs"
                        :sort-dir="tableColumn.sort"
                        @click="emit('change:sort', tableColumn)"
                    >
                        {{ tableColumn.name }}
                    </sort-th>

                    <th v-else scope="col" :class="tableColumn.classNames" class="resource-table__header-col">
                        {{ tableColumn.name }}
                    </th>
                </template>
            </tr>
        </thead>

        <tbody>
            <tr v-if="isCollectionLoading">
                <td class="resource-table__spinner" colspan="6">
                    <vx-icon name="spinner" :size="24"></vx-icon>
                </td>
            </tr>

            <tr v-else-if="hasLoadingError">
                <td colspan="6">
                    <alert-error />
                </td>
            </tr>

            <tr v-else-if="!hasData">
                <td colspan="6">
                    <alert-no-results />
                </td>
            </tr>

            <template v-else>
                <slot name="table-row" v-for="(entity, index) in collection" :entity="entity" :index="index"></slot>
            </template>
        </tbody>
    </table>
</template>

<script setup>
import { computed } from 'vue';
import { VxIcon } from '@voxie/frontend-components-v3';
import AlertNoResults from '~/components/general/AlertNoResults.vue';
import AlertError from '~/components/general/AlertError.vue';
import SortTh from '~/components/general/SortTh.vue';

const props = defineProps({
    tableColumns: { type: Array, required: true },
    selectAllRowsFeature: Boolean,
    isSortEnable: {
        type: Boolean,
        default: false,
    },
    isCollectionLoading: Boolean,
    hasLoadingError: Boolean,
    collection: { type: Array, required: true },
});

const emit = defineEmits(['change:sort', 'change:select-all']);

const hasData = computed(() => props.collection.length > 0);
</script>

<style lang="scss">
.resource-table__header-col {
    font-family: var(--font-open-sans);
    font-weight: var(--weight-regular);
    font-size: 0.8125rem;
    color: var(--color-grey-600);
    text-align: left;
    padding: 8px 16px;
}

.resource-table__spinner {
    text-align: center;
}
</style>
